export default function isLocalhost() {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'bs-local.com'
  );
}
